import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { useNavigate } from 'react-router-dom'

export default function ResetPassword() {
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)
  const [loading, setLoading] = useState(false)
  const [validSession, setValidSession] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    // Supabase puts the token in the URL hash — check for active session
    supabase.auth.getSession().then(({ data }) => {
      if (data.session) setValidSession(true)
    })

    // Listen for auth state change from the magic link
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') setValidSession(true)
    })
    return () => subscription.unsubscribe()
  }, [])

  const handleSubmit = async () => {
    setError('')
    if (!password) { setError('Please enter a new password'); return }
    if (password.length < 6) { setError('Password must be at least 6 characters'); return }
    if (password !== confirm) { setError('Passwords do not match'); return }

    setLoading(true)
    const { error } = await supabase.auth.updateUser({ password })
    setLoading(false)

    if (error) {
      setError(error.message)
    } else {
      setSuccess(true)
      setTimeout(() => navigate('/'), 2000)
    }
  }

  if (success) {
    return (
      <div style={{ maxWidth: 400, margin: '80px auto', textAlign: 'center' }}>
        <div style={{ fontSize: 32, marginBottom: 16 }}>✓</div>
        <h2 style={{ fontFamily: 'var(--display)', fontSize: 22, marginBottom: 8 }}>Password updated</h2>
        <p style={{ color: 'var(--text3)', fontSize: 13 }}>Redirecting you to the dashboard...</p>
      </div>
    )
  }

  if (!validSession) {
    return (
      <div style={{ maxWidth: 400, margin: '80px auto', textAlign: 'center' }}>
        <p style={{ color: 'var(--text3)', fontSize: 13, fontFamily: 'var(--mono)' }}>
          Verifying reset link...
        </p>
      </div>
    )
  }

  return (
    <div style={{ maxWidth: 400, margin: '80px auto' }}>
      <h1 style={{ fontFamily: 'var(--display)', fontSize: 28, fontWeight: 700, marginBottom: 8, letterSpacing: '-0.5px' }}>
        Choose a new password
      </h1>
      <p style={{ color: 'var(--text3)', fontSize: 13, marginBottom: 28 }}>
        Enter a new password for your EarningsEdge account.
      </p>

      {error && (
        <div style={{
          background: 'var(--red-bg)', border: '1px solid rgba(192,57,43,0.2)',
          borderRadius: 4, padding: '10px 14px', fontSize: 13,
          color: 'var(--red)', marginBottom: 16,
        }}>{error}</div>
      )}

      <input type="password" placeholder="New password" value={password}
        onChange={e => setPassword(e.target.value)}
        style={inputStyle} />
      <input type="password" placeholder="Confirm new password" value={confirm}
        onChange={e => setConfirm(e.target.value)}
        onKeyDown={e => e.key === 'Enter' && handleSubmit()}
        style={{ ...inputStyle, marginTop: 10 }} />

      <button onClick={handleSubmit} disabled={loading} style={{
        width: '100%', marginTop: 16, padding: '11px',
        background: 'var(--olive)', border: 'none', borderRadius: 4,
        color: '#fff', fontWeight: 600, fontSize: 14,
        cursor: loading ? 'not-allowed' : 'pointer',
        fontFamily: 'var(--sans)', opacity: loading ? 0.7 : 1,
      }}>
        {loading ? 'Updating...' : 'Update password'}
      </button>
    </div>
  )
}

const inputStyle = {
  width: '100%', padding: '10px 14px',
  background: 'var(--surface2)', border: '1px solid var(--border)',
  borderRadius: 4, color: 'var(--text)', fontSize: 14,
  fontFamily: 'var(--sans)', outline: 'none', display: 'block',
}
